import React, { Suspense, useEffect, useState } from "react";
import { useHistory } from "react-router";
import App from "@ipru-common/App";
import { Constants, ModelManager } from "@adobe/aem-spa-page-model-manager";
import ModelManagerUtils from "@ipru-common/utils/ModelManagerUtils";
import { ScreenLoaderProvider } from "../CommonComponents/ScreenLoader";
import { GlobalProvider, useGlobalContext } from "@ipru-common/context/GlobalContext";
import { RatesProvider } from "@ipru-common/context/RatesContext";
import { AppFormProvider } from "@ipru-common/context/AppFormContext";
import { getActiveLanguage } from "@ipru-common/utils/CommonFunctions";
import useBlackListedList from "@ipru-common/hooks/useBlackListedList";

export const withProviders = (Component) => (props) => {
  return (
    <Suspense>
      <ScreenLoaderProvider>
        <GlobalProvider pageModelPath={props.modelData?.[Constants.PATH_PROP]} defaultGlobalState={props.globalState}>
          <RatesProvider>
            <AppFormProvider>
              <Component {...props} />
            </AppFormProvider>
          </RatesProvider>
        </GlobalProvider>
      </ScreenLoaderProvider>
    </Suspense>
  );
};

function AemApp({ modelData, locationPathname }) {
  useEffect(() => {
    window?.onCsrLoaded?.();
  }, []);

  const [pageModel, setPageModel] = useState(modelData);

  // const [itemsData, setItemsData] = useState(modelData[Constants.ITEMS_PROP]);

  const history = useHistory();

  const { updateGlobalValue } = useGlobalContext();

  const { blacklistedContacts } = useBlackListedList();
  const syncLang = (lng) => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lng;
    }
  };
  useEffect(() => {
    updateGlobalValue("blacklistedContacts", blacklistedContacts);
  }, [blacklistedContacts]);

  useEffect(() => {
    window.addEventListener("popstate", handlePathChange);
    syncLang(getActiveLanguage().code);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handlePathChange);
    };
  }, []);

  function handlePathChange() {
    const currentPath = ModelManager.modelStore.rootPath;
    const activeLanguage = getActiveLanguage().code;
    syncLang(activeLanguage);
    const newPath = ModelManagerUtils.replaceLanguageInModelPath({
      languageCode: activeLanguage,
      modelPath: currentPath,
    });

    updateGlobalValue("pageModelPath", newPath);

    ModelManager.getData({ path: newPath }).then((model) => {
      setPageModel(model);
    });
  }

  return (
    <App
      history={history}
      cqChildren={pageModel[Constants.CHILDREN_PROP]}
      cqItems={pageModel[Constants.ITEMS_PROP]}
      cqItemsOrder={pageModel[Constants.ITEMS_ORDER_PROP]}
      cqPath={pageModel[Constants.PATH_PROP]}
      locationPathname={locationPathname || window?.location?.pathname}
    />
  );
}

export default withProviders(AemApp);
